/*=========================================================================================
  File Name: moduleUnitState.js
  Description: Unit Module State
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
    places: [],
  };
  